/** @format */

import React from "react";
import { PackageOpenIcon, TruckIcon } from "lucide-react";
import { useTranslation } from "react-i18next";
import style from "./AddressTypeSwitch.module.scss";
import cn from "classnames";

const AddressTypeSwitch = ({ value = 1, onChange }) => {
  const { t } = useTranslation();

  const handleClick = (newValue) => {
    if (onChange && value !== newValue) {
      onChange(newValue);
    }
  };

  return (
    <div className={style.switchContainer}>
      <button
        type="button"
        className={cn(style.switchButton, {
          [style.active]: value === 0,
        })}
        onClick={() => handleClick(0)}
      >
        <PackageOpenIcon size={16} color={value === 0 ? "#FFFFFF" : "#4A5565"} />
        <span>{t("addressType.loading")}</span>
      </button>
      <button
        type="button"
        className={cn(style.switchButton, {
          [style.active]: value === 1,
        })}
        onClick={() => handleClick(1)}
      >
        <TruckIcon size={16} color={value === 1 ? "#FFFFFF" : "#4A5565"} />
        <span>{t("addressType.unloading")}</span>
      </button>
    </div>
  );
};

export default AddressTypeSwitch;
